import * as Yup from 'yup';

export const providerProfileLocationSchema = Yup.object().shape({
  city: Yup.string().default('').required().nullable(),
  state: Yup.string().default('').required().nullable(),
  zip: Yup.string().default('').required().nullable(),
});

export type ProviderProfileLocationSchema = Yup.InferType<typeof providerProfileLocationSchema>;
